import React from 'react';
import FollowUpAgenciamentoRegistrationPageBase from './FollowUpAgenciamentoRegistrationPageBase';

export default function FollowUpAgenciamentoRegistrationImportMaritimoPage(props) {
  return (
    <FollowUpAgenciamentoRegistrationPageBase
      {...props}
      urlPosSalvar={(created) => `/importacao/agenciamento/maritimo/follow-up?processo=${created?.numero || ''}`}
      breadcrumbConfig={(t, actionName) => [
        {
          link: { to: '/', name: t('com.muralis.qcx.inicio') },
        },
        {
          link: { to: '/importacao/agenciamento/maritimo', name: 'Importação Agenciamento Marítimo' },
        },
        {
          link: { to: '/importacao/agenciamento/maritimo/follow-up', name: 'Follow-Up' },
        },
        { text: { name: t('com.muralis.qcx.registro') } },
        { text: { name: actionName } },
      ]}
    />
  );
}
